import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import BooksPage from './pages/BooksPage';
import MusicPage from './pages/MusicPage';
import ContactPage from './pages/ContactPage';
import StockFatherPage from './pages/StockFatherPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/books" element={<BooksPage />} />
          <Route path="/music" element={<MusicPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/script" element={<StockFatherPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
